// The suspect trigger list the user submitted
type DesiredFood = {
  id: string;
  display_name: string;
};

// Backend codes for requested support follow-up after app check-in.
export enum ConnectPreference {
  Book = 'book',
  Chat = 'chat',
  Nothing = 'nothing',
}

// Payload specific for Suspect Identification, returned by:
// `/private/dashboard/user/{user_uuid}/suspect-identification/{id}`
export type SuspectIdentificationBlockData = {
  id: string;
  user_block_id: string;
  desired_food_list: DesiredFood[];
  open_feedback: string | null;
  connect_preference: ConnectPreference | null;
  ended_on: string | null;
};

// A trigger food identified for the block, returned by:
// `/private/user/blocks/{user_block_id}/foods`
export type UserBlockFood = {
  id: string;
  name: string;
  display_name: string;
  image_url: string | null;
};
